import React, { useEffect } from "react";
import NumberFormat from "react-number-format";
import { Box, CardContent, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Typography } from "components/Shared/Typography";
import { getPurchaseDetails } from "redux/actions/purchase";
import { useAppDispatch } from "redux/store/hooks";
import usePurchaseHistorySelector from "redux/selectors/purchaseHistorySelectors";
import { IPurchaseHistoryItem } from "redux/reducers/purchaseHistorySlice";
import PurchasedPointHistoryItem from "./purchasedPointHistoryItem";
import "./styles.scss";
import { Card } from "components/Shared/Card";
import moment from "moment";
import { HOLIDAY_DATE_FORMAT } from "utils/constants";

const PurchasePointsHistory = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { purchaseHistory, presentAvailablePointsAmount, loading } =
    usePurchaseHistorySelector();

  useEffect(() => {
    dispatch(getPurchaseDetails());
  }, [dispatch]);

  const generatePointPurchaseHistory = (
    purchaseHistory: IPurchaseHistoryItem[]
  ) => {
    if (loading) {
      return (
        <Box className="loading_spinner_box">
          <CircularProgress size={20} color="success" />
        </Box>
      );
    }
    if (purchaseHistory.length === 0) {
      return (
        <div className="empty_purchase_history">
          <span>{t("purchaseHistory.label.emptyRecords")}</span>
        </div>
      );
    }
    return purchaseHistory.map(
      (purchaseHistoryItem: IPurchaseHistoryItem, index: number) => {
        return (
          <PurchasedPointHistoryItem
            key={index}
            purchaseHistoryItem={purchaseHistoryItem}
            index={index}
          />
        );
      }
    );
  };
  
  const currentDate = () => moment(new Date()).format(HOLIDAY_DATE_FORMAT);

  return (
    <div className="purchase_points_history">
      <Card>
        <CardContent className="card-content">
          <div className="page_heading">{t("purchaseHistory.title")}</div>
          <div className="present_available_points_row">
            <div className="flex-left">
              <span className="present_available_points_label">
                {t("purchaseHistory.label.presentPointsText.part1")}
              </span>
              <span className="present_available_points_date">
                ({currentDate()} )
              </span>
            </div>
            <div className="points_area">
              <NumberFormat
                value={
                  presentAvailablePointsAmount
                    ? presentAvailablePointsAmount
                    : 0
                }
                displayType={"text"}
                className="present_available_points_amount"
                thousandSeparator={true}
                // suffix={t("purchaseHistory.label.presentPointsText.part2")}
              />
              <Typography className="points" variant="" component="div">
                {t("purchaseHistory.label.presentPointsText.part2")}
              </Typography>
            </div>
          </div>

          <div className="purchased_points_history">
            {generatePointPurchaseHistory(purchaseHistory)}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PurchasePointsHistory;
